import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { useSnackbar } from "src/utils/useSnackbar";
import { useTranslation } from "react-i18next";

type saveCommentOptions = {
    comment: string;
    ssqPostElementId: number;
};

export const useSaveComment = () => {
    const snackbar = useSnackbar();
    const { t } = useTranslation();
    return useMutation({
        mutationFn: async (options: saveCommentOptions) => {
            const { comment, ssqPostElementId } = options;
            await loggedInApiCall.post(`/api/diagnostic/ssq_post_comment`, {
                comment: comment,
                ssqPostElementId: ssqPostElementId,
            });
            return true;
        },
        onError: (error) => {
            console.error("Note saving step failed : ", error);
            snackbar.setSnackbarProps({
                type: "error",
                message: t("property.note.save_error"),
            });
        },
        onSettled: () => {},
    });
};

export const useDeleteComment = () => {
    const snackbar = useSnackbar();
    const { t } = useTranslation();
    return useMutation({
        mutationFn: async (commentId: string) => {
            await loggedInApiCall.delete(`/api/diagnostic/ssq_post_comment/${commentId}`);
            return true;
        },
        onError: (error) => {
            console.error("Note deletion failed : ", error);
            snackbar.setSnackbarProps({
                type: "error",
                message: t("property.note.deletion_error"),
            });
        },
        onSettled: () => {},
    });
};
